import { container } from './material-kit-react.js';

const signupPageStyle = {
  authPage: {
    backgroundColor: '#0B100D',
    minHeight: '100vh'
  },
  container: {
    ...container,
    boxSizing: 'border-box',
    color: '#FFFFFF',
    flex: '1 0 auto',
    paddingBottom: '80px',
    paddingTop: '150px',
    position: 'relative',
    width: '100%',
    zIndex: '2',
    '@media (max-width: 600px)': {
      paddingBottom: '56px',
      paddingLeft: '16px',
      paddingRight: '16px',
      paddingTop: '116px'
    }
  },
  authGrid: {
    minWidth: 0
  },
  authCard: {
    border: '1px solid rgba(255,255,255,0.12) !important',
    borderRadius: '24px !important',
    boxShadow: '0 30px 80px rgba(0,0,0,0.32) !important',
    marginBottom: '30px !important',
    marginTop: '20px !important',
    overflow: 'hidden'
  },
  cardHidden: {
    opacity: '0',
    transform: 'translate3d(0, -60px, 0)'
  },
  pageHeader: {
    alignItems: 'stretch',
    border: '0',
    display: 'flex',
    flexDirection: 'column',
    height: 'auto',
    margin: '0',
    minHeight: '100vh',
    overflow: 'hidden',
    padding: '0',
    position: 'relative',
    '&:before': {
      background: 'radial-gradient(circle, rgba(183,238,0,0.2) 0%, rgba(183,238,0,0) 68%)',
      height: '620px',
      left: '-180px',
      top: '-250px',
      width: '620px'
    },
    '&:after': {
      backgroundImage: 'radial-gradient(rgba(255,255,255,0.13) 1px, transparent 1px)',
      backgroundSize: '24px 24px',
      bottom: 0,
      maskImage: 'linear-gradient(to top, rgba(0,0,0,0.8), transparent)',
      opacity: 0.18,
      right: 0,
      top: 0,
      width: '46%'
    },
    '&:before,&:after': {
      content: '""',
      display: 'block',
      pointerEvents: 'none',
      position: 'absolute',
      zIndex: '1'
    },
    '& footer': {
      flex: '0 0 auto',
      position: 'relative',
      width: '100%',
      zIndex: '2'
    }
  },
  form: {
    margin: '0'
  },
  cardHeader: {
    background: 'linear-gradient(135deg, #0B100D 0%, #152033 100%) !important',
    borderBottom: '3px solid #B7EE00 !important',
    borderRadius: '0 !important',
    boxShadow: 'none !important',
    margin: '0 !important',
    padding: '25px 20px 22px !important',
    width: 'auto !important',
    '& h4': {
      fontSize: '1.25rem !important',
      fontWeight: '850 !important',
      letterSpacing: '-0.02em',
      margin: '0'
    }
  },
  socialIcons: {
    fontSize: '20px',
    height: '100%',
    left: '0',
    lineHeight: '41px',
    maxWidth: '24px',
    top: '0',
    transform: 'none',
    width: '100%'
  },
  divider: {
    marginBottom: '0',
    marginTop: '30px',
    textAlign: 'center'
  },
  cardFooter: {
    alignItems: 'center',
    border: '0',
    borderRadius: '6px',
    display: 'flex',
    flexWrap: 'wrap',
    gap: '8px',
    justifyContent: 'center !important',
    paddingBottom: '22px !important',
    paddingTop: '8px !important'
  },
  socialLine: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'center',
    marginTop: '0.6rem',
    padding: '0',
    textAlign: 'center'
  },
  inputIconsColor: {
    color: '#5B655B'
  },
  forgotButton: {
    color: '#606960',
    fontSize: '11px',
    margin: 0,
    padding: '0',
    textTransform: 'none'
  },
  normalButton: {
    backgroundColor: '#B7EE00 !important',
    borderRadius: '12px !important',
    boxShadow: 'none !important',
    color: '#111411 !important',
    margin: '4px !important',
    minHeight: '44px',
    padding: '10px 18px !important',
    textTransform: 'none !important',
    '&:hover,&:focus': {
      backgroundColor: '#CCFF1C !important',
      boxShadow: '0 10px 24px rgba(183,238,0,0.2) !important'
    }
  },
  inputRtl: {
    '& label': {
      left: 'auto',
      right: 28,
      transformOrigin: 'top left'
    },
    '& legend': {
      textAlign: 'right'
    }
  },
  rtlDescription: {
    fontFamily: 'inherit',
    textAlign: 'right'
  },
  ltrDescription: {
    fontFamily: 'inherit',
    textAlign: 'left'
  }
};

export default signupPageStyle;
